import styled from 'styled-components';

export const UserTBody = styled.div`
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns: 6.76% 19.96% 32.16% 13.36% 14.36% 13.36%;
  align-items: center;
`;
